import React, { PureComponent } from 'react';
import CommonList from '../../components/CommonLists/list';
import moment from 'moment';
import './index.less';
const columns = [
  {
    title: '名称',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '描述',
    dataIndex: 'des',
    key: 'des'
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
    key: 'update_time',
    width: '12%',
    render: text => {
      return <p>{moment(text).format('YYYY-MM-DD h:mm:ss')}</p>;
    }
  }
];

@CommonList(columns, 'ads')
class AdsList extends PureComponent {
  constructor() {
    super();
  }
  componentDidMount() {}

  render() {
    return <div />;
  }
}

export default AdsList;
